import { appendAppLog } from '../../platform/appLog';
import { archiviereDatei } from '../../platform/archive';

/**
 * Schafft die Datei zu einem Medien-Eintrag beiseite, falls eine hinterlegt ist, und meldet
 * einen Fehlschlag über `onDeleteFailed` — ohne selbst zu werfen.
 *
 * Getrennt von `MediaTabs.tsx` (React, CSS-Module), damit sich der Entscheid ohne DOM und ohne
 * Testing-Library prüfen lässt — dasselbe Vorgehen wie bei `handwritingSave.ts`.
 *
 * ⚠️ **Archiviert, nicht gelöscht** (Entscheidung des Nutzers, 2026-09-13). Die Aufnahme
 * wandert nach `old/<Löschdatum>/logs/…` und verschwindet erst nach der eingestellten Frist —
 * dieselbe zweistufige Behandlung wie beim Löschen einer ganzen Prüfung (s.
 * `platform/archive.ts`). Der Grund ist derselbe: eine Aufnahme ist Beweismaterial, und ein
 * Fehlgriff mitten in der Prüfung darf nicht endgültig sein. Beglaubigung und Markierebene
 * nimmt `archiviereDatei` mit.
 *
 * Die Streichung aus dem Bogen geschieht in jedem Fall, auch wenn das Verschieben scheitert:
 * der Prüfer soll nicht an einem Eintrag hängen bleiben, den er gerade nicht wegbekommt — die
 * liegengebliebene Datei ist das kleinere Problem.
 */
export async function removeMediaFile(
  fileName: string | undefined,
  onDeleteFailed: () => void,
): Promise<void> {
  if (!fileName) return;
  try {
    const gelungen = await archiviereDatei(fileName, appendAppLog);
    if (!gelungen) onDeleteFailed();
  } catch {
    onDeleteFailed();
  }
}
